import './index.scss';
import classNames from 'classnames';
import React from 'react';
const CellTabs = ({ descriptor, tabs, activeTabIndex, onTabChange }) => {
    return (React.createElement("div", { className: 'cell-tabs' }, tabs.map((tab, tabIndex) => {
        const tabClassName = classNames('cell-tab', {
            active: activeTabIndex === tabIndex,
            'mid-confidence': tab.confidenceLevel === 'mid',
            'low-confidence': tab.confidenceLevel === 'low',
        });
        return React.createElement("div", { key: `${descriptor}-${tabIndex}-tab`, className: tabClassName, title: tab.text, onClick: () => onTabChange(tabIndex) },
            React.createElement("div", { className: 'cell-tab-text' }, tab.text));
    })));
};
export default CellTabs;
